import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    eventName: String,
    eventCategory: String,
    eventAction: String,
    threshold: Number
  }

  connect() {
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      {
        threshold: this.thresholdValue || 0.5,
        rootMargin: "0px"
      }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.trackEvent()
        // Disconnect after first visibility to prevent multiple events
        this.observer.disconnect()
      }
    })
  }

  trackEvent() {
    const eventParams = {
      category: this.eventCategoryValue || "Visibility",
      action: this.eventActionValue || "View",
      label: this.element.id || this.element.className || "unknown_element"
    }
    console.debug("Visibility tracker - Element:", this.element)
    console.debug("Visibility tracker - Event params:", eventParams)
    
    if (window.dataLayer) {
      window.dataLayer.push({
        event: this.eventNameValue || "element_visible",
        ...eventParams
      });
      console.debug("Visibility tracker - Event pushed to dataLayer")
    } else {
      console.warn("Visibility tracker - dataLayer not available")
    }
  }
} 